import * as React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';

import Typography from '@mui/material/Typography';
import { Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DoubleArrowSharpIcon from '@mui/icons-material/DoubleArrowSharp';
import FALLBACK_IMAGE from '../../../assets/images/fallback_image.png';

const ArticleCard = (props) => {
  let navigate = useNavigate();
  let convertDateTime = (input) => {
    let date = new Date(input);
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const handleNavigation = () => {
    navigate(`/stories/${props.id}`);
    navigate(0);
  };

  const onMediaFallback = (event) => (event.target.src = FALLBACK_IMAGE);

  return (
    <Grid
      item
      component={Card}
      elevation={10}
      xs={12}
      lg={3.8}
      sx={{
        borderRadius: 5,
        position: 'relative',
        margin: 1,
        padding: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
          transform: 'scale3d(1.03, 1.03, 1)',
          zIndex: 1,
          '& .thumbnail': {
            maxHeight: '400px',
            transition: 'max-height 0.7s cubic-bezier(.13,.04,0,.99)',
          },
        },
        '& .thumbnail': {
          maxHeight: '200px',
          transition: 'max-height 1s cubic-bezier(.15,.95,.26,1)',
        },
        '.MuiCardContent-root': {
          padding: '0.5rem',
          display: 'inline-block',
        },
      }}>
      <CardActionArea onClick={handleNavigation}>
        <CardMedia
          component='img'
          className='thumbnail'
          src={`https://hnjiwdxlyyttjbocwpfw.supabase.co/storage/v1/object/public/blog/thumbnail${props.id}.png`}
          alt='very_cool_thumbnail_that_did_not_load.png'
          sx={{
            position: 'relative',
            maxHeight: '200px',
            width: '100%',
            objectFit: 'cover',
            objectPosition: 'center 66%',
            borderRadius: 2,
          }}
          onError={onMediaFallback}
        />
        <CardContent>
          <Typography
            variant='body1'
            component='h3'
            sx={{
              fontWeight: 'bold',
              position: 'relative',
            }}>
            {props.header}
          </Typography>
        </CardContent>
        <CardContent>
          <Typography variant='body2' component='h3' color='info.main' sx={{ fontWeight: 'light' }}>
            {convertDateTime(props.date)}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size='large' endIcon={<DoubleArrowSharpIcon />} onClick={handleNavigation}>
            Read More
          </Button>
        </CardActions>
      </CardActionArea>
    </Grid>
  );
};

export default ArticleCard;
